import * as types from './actionTypes';
import {API_ROOT} from '../../baseUrls';
import {buildFormData} from './actionUtils'

export function addFriend(mindfile) {
  return function(dispatch, getState) {
    dispatch({
      type: types.ADD_FRIEND,
      payload: mindfile,
    })
  }
}

export function removeFriend(mindfile) {
  return function(dispatch, getState) {
    dispatch({
      type: types.REMOVE_FRIEND,
      payload: mindfile,
    })
  }
}

export function updateEmail(email) {
  return function(dispatch, getState) {
    dispatch({
      type: types.UPDATE_EMAIL,
      payload: email,
    })
  }
}

export function updateMindfileName(mindfileName) {
  return function(dispatch, getState) {
    dispatch({
      type: types.UPDATE_MINDFILE_NAME,
      payload: mindfileName,
    })
  }
}

export function updateBirthday(birthday) {
  return function(dispatch, getState) {
    dispatch({
      type: types.UPDATE_BIRTHDAY,
      payload: birthday,
    })
  }
}

export function updateLocation(location) {
  return function(dispatch) {
    dispatch({
      type: types.UPDATE_LOCATION,
      payload: location,
    })
  }
}

export function updateMindfilePrivacyLevel(privacyLevel) {
  return function(dispatch, getState) {
    dispatch({
      type: types.UPDATE_MINDFILE_PRIVACY_LEVEL,
      payload: privacyLevel,
    })
  }
}

export function updateMindfileGroup(group) {
  return function(dispatch, getState) {
    dispatch({
      type: types.UPDATE_MINDFILE_GROUP,
      payload: group,
    })
  }
}

export function updateReceiveEmail(receiveEmail) {
  return function(dispatch, getState) {
    dispatch({
      type: types.UPDATE_RECEIVE_EMAIL,
      payload: receiveEmail
    })
  }
}

export function addFolder(name, description, callback = (folder) => {}) {
  return function(dispatch, getState) {
    const state = getState();
    const mid = state.mindfile.id;
    const authToken = state.auth.authenticity_token;

    const formData = new FormData();
    formData.append("folder[name]", name);
    formData.append("folder[description]", description);
    // formData.append("authenticity_token", authToken);
    let folder = {id: null, name: name, description: description, item_count: 0};
    fetch(`${ API_ROOT }/mindfiles/${ mid }/folders/create`, {
      method: 'POST',
      credentials: 'include',
      body: formData,
      headers: {'X-CSRF-Token': authToken},
    })
    .then(resp => resp.json())
    .then(data => {
      folder.id = data.id;
      dispatch({
        type: types.ADD_FOLDER,
        payload: data,
      })
      return data;
    })
    .then(folder => !!callback && callback(folder))
    .catch(error => console.error(error));
  }
}

export function removeFoldersAndDeleteItems(folderIds, callback = (removed_ids) => {}) {
  return removeFoldersOpts(folderIds, null, callback);
}
export function removeFoldersAndMoveItems(folderIds, destId, callback = (removed_ids) => {}) {
  if(!destId){
    return null;
  }
  return removeFoldersOpts(folderIds, destId, callback);
}
export function removeFoldersOpts(folderIds, destId, callback = (removed_ids) => {}) {
  return function(dispatch, getState) {
    const state = getState();
    const mid = state.mindfile.id;
    const authToken = state.auth.authenticity_token;
    let endpoint;
    let formData;
    if(destId !== null){
      endpoint = 'move';
      formData = buildFormData({folder_ids: [...folderIds], dest_id: destId})
    }else{
      endpoint = 'destroy';
      formData = buildFormData({folder_ids: [...folderIds]})
    }
    fetch(`${ API_ROOT }/mindfiles/${ mid }/folders/delete_${endpoint}`, {
      method: 'DELETE',
      credentials: 'include',
      body: formData,
      headers: {'X-CSRF-Token': authToken},
    })
      .then((resp) => {
        return resp.json();
      })
      .then((data) => {
        // if(data.status !== 'ok') throw new Error(data.text);
        dispatch({
          type: types.REMOVE_FOLDERS,
          payload: data.removed,
        })
        return data;
      })
      .then((data) => {
        if(typeof(callback) === 'function') {
          callback(data.removed)
        }
      })
      .catch(error => console.error(error));
    // .then(() => {
    // })
  }
}
export function moveFolderItems(srcIds, destId, callback = () => {}) {
  return function(dispatch, getState) {
    const state = getState();
    const mid = state.mindfile.id;
    const authToken = state.auth.authenticity_token;

    fetch(`${ API_ROOT }/mindfiles/${ mid }/folders/move_items`, {
      method: 'POST',
      credentials: 'include',
      // body: formData,
      body: buildFormData({
        mindfile_id: mid,
        src_ids: srcIds,
        dest_id: destId}),
      headers: {'X-CSRF-Token': authToken},
    })
    .then((resp) => {
      return resp.json();
    })
    .then(callback)
    .catch(error => console.error(error))
  }
}

export function updateFolders(folders, callback = (folders) => {}) {
  return function(dispatch, getState) {
    const state = getState();
    const mid = state.mindfile.id;
    const authToken = state.auth.authenticity_token;

    fetch(`${API_ROOT}/mindfiles/${ mid }/folders/update`, {
      method: 'POST',
      credentials: 'include',
      body: buildFormData({
        mindfile_id: mid,
        folders:folders.map(f => ({
          id: f.id,
          folder: {
            name: f.name,
            description: f.description
          }
        }))
      }),
      headers: {'X-CSRF-Token': authToken},
    })
      .then((resp) => {
        return resp.json();
      })
      .then((data) => {
        dispatch({
          type: types.UPDATE_FOLDERS,
          payload: data.updated,
        });
        return data.updated;
      })
      .then((data) => {
        callback(data);
      })
      .catch(error => console.error(error));
  }
}

export function removeItems(selectedIds, callback = () => {}) {
  return function(dispatch, getState) {
    const state = getState();
    const mid = state.mindfile.id;
    const authToken = state.auth.authenticity_token;

    const formData = new FormData();
    formData.append("_method", 'delete');
    selectedIds.forEach((id,i) => {
      formData.append('item_ids[]', id);
    });

    fetch(`${ API_ROOT }/mindfiles/${ mid }/items/delete`, {
      method: 'DELETE',
      credentials: 'include',
      body: formData,
      headers: {'X-CSRF-Token': authToken},
    })
      .then((resp) => {
        return resp.json();
      })
      .then((data) => {
        if(data.status !== 'ok') throw new Error(data.text);
        dispatch({
          type: types.REMOVE_ITEMS,
          payload: data.removed_ids,
        })
      })
      .catch(error => console.error(error))
      .finally(() => callback());
  }
}

export function moveItems(selectedIds, destId, callback = () => {}) {
  return function(dispatch, getState) {
    const state = getState();
    const mid = state.mindfile.id;
    const authToken = state.auth.authenticity_token;

    const formData = new FormData();
    formData.append('dest_id', destId);
    selectedIds.forEach((id,i) => {
        formData.append('item_ids[]', id);
    });
    fetch(`${ API_ROOT }/mindfiles/${ mid }/items/move`, {
      method: 'POST',
      credentials: 'include',
      body: formData,
      headers: {'X-CSRF-Token': authToken},
    })
    .then((resp) => {
      return resp.json();
    })
    .then((data) => {
      dispatch({
        type: types.GET_MINDFILE_ITEMS,
        payload: data,
      })
    })
    .catch(error => console.error(error))
    .finally(() => callback());
  }
}

const cleanLocation = (location) => {
  if(!location){
    return {};
  }
  const {country, region, locality, latitude, longitude} = location;
  if(!country && !region && !locality && !longitude && !latitude){
    return {};
  }
  const hash = {
    country: location.country || "",
    region: location.region || "",
    locality: location.locality || "",
  };
  if(!!location.latitude){
    hash.latitude = location.latitude;
  }
  if(!!location.longitude){
    hash.longitude = location.longitude;
  }
  return hash;
}
const cleanItem = (item) => {
  const keywordsStrings = item.keywords ? item.keywords.map(k => typeof(k) === "string" ? k : k.text) : [];
  const peopleStrings = item.people ? item.people.map(p => typeof(p) === "string" ? p : p.name) : [];
  return {
    name: item.name,
    description: item.description ? item.description : "",
    keywords_strings: keywordsStrings,
    people_strings: peopleStrings,
    emotion: item.emotion ? item.emotion : '',
    beme: item.beme ? item.beme : '',
    date: item.date,
    folder_id: item.folder ? item.folder.id : null,
    set_location: cleanLocation(item.location),
  };
};

export function saveItem(item, itemCallback){
  itemCallback = itemCallback ? itemCallback : () => {};
  return function (dispatch, getState) {
    const authToken = getState().auth.authenticity_token;
    const {set_location, keywords_strings=[], people_strings=[], ...cleaned} = cleanItem(item)
    cleaned.keywords_string = keywords_strings.join(',');
    cleaned.people_string = people_strings.join(',');
    fetch(
      `${API_ROOT}/mindfiles/${item.mindfile_id}/items/${item.id}/tag`,
      {
        method: "POST",
        credentials: "include",
        body: buildFormData({
          item: cleaned,
          location: set_location
        }),
        headers: {'X-CSRF-Token': authToken},
      }
    ).then((resp) => resp.json())
    .then((data) => {
      dispatch({
        type: types.GET_MINDFILE_ITEMS,
        payload: [data],
      })
      return data;
    }).then((data) => {
      itemCallback(data);
    })
    .catch(error => console.error(error))
  }
}

export function updateItemSharing(mid, mindfile_item_id, sharing, shareOpt, callback = (data) => {}, doDispatch=true) {
  return function (dispatch, getState) {
    fetch(`${ API_ROOT }/mindfiles/${ mid }/items/${ mindfile_item_id }/sharing`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'X-CSRF-Token': getState().auth.authenticity_token,
        "Content-Type": "application/json"
      },
      body:JSON.stringify({
        share: sharing ? "1" : "0",
        ...(!shareOpt ? {} : {option: shareOpt})
      })
    })
      .then(response => response.json())
      .then(data => {
        doDispatch && dispatch({
          type: types.GET_MINDFILE_ITEM,
          payload: data
        });
        return data;
      })
      .then(data => callback(data))
      .catch(err => console.error(err))
      .finally(() => {
          doDispatch && dispatch({
            type: types.SET_VIEW_ITEM_STATUS,
            payload: 'done'
          })
        }
      );
  }
}

export function updateItemViewCount(mid, mindfile_item_id, callback=()=>{}) {
  return function (dispatch, getState) {
    fetch(`${ API_ROOT }/mindfiles/${ mid }/items/${ mindfile_item_id }/viewing`, {
      method: 'POST',
      credentials: 'include',
      headers: {'X-CSRF-Token': getState().auth.authenticity_token},
    })
      .then(response => response.json())
      .then(data => callback(data))
      .catch(err => console.error(err));
  }
}

export function addJournalPost(item, callback = () => {}) {
  return addItem("journal_posts", {journal_post: {
      title: item.name,
      post_markup: item.description,
      item: cleanItem(item),
    }}, types.ADD_JOURNAL_POST, callback);
}

export function addFavorite(item, callback = () => {}) {
  return addItem("favorites", {favorite: {
      title: item.name,
      description: item.description,
      item: cleanItem(item),
    }}, types.ADD_FAVORITE, callback);
}

export function addLink(item, callback = () => {}) {
  return addItem("links", {link: {
      url: item.name,
      description: item.description,
      item: cleanItem(item),
    }}, types.ADD_LINK, callback);
}

function addItem(type, body, dispatch, callback = () => {}) {
  return function(dispatch, getState) {
    const state = getState();
    const mid = state.mindfile.id;
    const authToken = state.auth.authenticity_token;
    if(!["links", "favorites", "journal_posts", "survey_attempts"].includes(type)){
      return;
    }

    fetch(`${ API_ROOT }/mindfiles/${ mid }/${type}`, {
      method: 'POST',
      credentials: 'include',
      body: buildFormData(body),
      headers: {'X-CSRF-Token': authToken},
    })
      .then(resp => resp.json())
      .then(data => {
        dispatch({
          type: dispatch,
          payload: {data},
        })
      })
      .catch(error => console.error(error))
      .finally(() => callback());
  }
}

export function setSpacecastSetting(setting, value) {
  return function (dispatch, getState) {
    const state = getState();
    const mid = state.mindfile.id;
    const authToken = state.auth.authenticity_token;
    const formData = new FormData();
    formData.append(`mindfile[${setting}]`, value ? 1 : 0);
    // formData.append("authenticity_token", state.auth.authenticity_token);
    fetch(`${API_ROOT}/mindfiles/${mid}/spacecast-settings`, {
      method: 'POST',
      credentials: 'include',
      body: formData,
      headers: {'X-CSRF-Token': authToken},
    })
    .then((resp) => {
      resp.json().then(settings => {
        dispatch({ type: types.UPDATE_SPACECAST_SETTINGS, payload: settings });
      })
      .catch((err) => {
        console.error(err);
      });
    })
    .catch((err) => {
      console.error(err);
    });
  }
}

export function updateMindfilePicture(file) {
  return function(dispatch, getState) {
    const state = getState();
    const mindfile = state.mindfile;
    const authToken = state.auth.authenticity_token;
    const formData = new FormData();
    formData.append("avatar", file, file.name);
    // formData.append("authenticity_token", authToken);

    dispatch({
      type: types.SET_MINDFILE_PICTURE_UPLOADING,
      payload: true,
    });
    fetch(`${API_ROOT}/mindfiles/${mindfile.id}/upload-avatar`, {
      method: "POST",
      credentials: "include",
      body: formData,
      headers: {'X-CSRF-Token': authToken},
    }).finally(() => {
      dispatch({
        type: types.SET_MINDFILE_PICTURE_UPLOADING,
        payload: false,
      });
    });
  };
}

export function saveUserViewOpts(page, viewOpts, callback=()=>{}) {
  return function (dispatch, getState) {
    const state = getState();
    const mid = state.mindfile.id;
    const authToken = state.auth.authenticity_token;
    fetch(`${API_ROOT}/mindfiles/${mid}/view_options/update`,{
      method: "POST",
      credentials: 'include',
      body: JSON.stringify({
        page: page,
        view_options: viewOpts ? viewOpts : {}
      }),
      headers: {
        "Content-Type": "application/json",
        'X-CSRF-Token': authToken
      },
    })
      .then(resp => resp.json())
      .then(data => {
        dispatch({type: types.UPDATE_PAGE_VIEW_OPTS, payload: data});
        return data;
      })
      .then(viewOpts => callback(viewOpts))
      .catch(err => console.error(err));
  }
  // return function(dispatch, getState) {
  //   const state = getState();
  //   // console.log("save", page, viewOpts, state);
  //   const uid = state.auth.uid;
  //   const mid = state.mindfile;
  //   const authToken = state.auth.authenticity_token;
  // }
}
